// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from "react";
import clsx from "clsx";
import styles from "./styles.css.js";
var Arrow = function(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.arrow, props.position && styles["arrow-position-".concat(props.position)])
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles["arrow-outer"]
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles["arrow-inner"]
    }));
};
export default /*#__PURE__*/ React.memo(Arrow); //# sourceMappingURL=arrow.js.map
